import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import { resolveTitledBody } from "@/components/storyboard/text/utils/resolveTitledBody";
import type { TextTitledBodyData } from "@/types/storyboard";

interface Props {
  /** Older storyboards carry a bare markdown string instead. */
  text: TextTitledBodyData | string;
}

export const TextAnalogy = ({ text }: Props) => {
  const { title, body } = resolveTitledBody(text);

  return (
    <ContentBlock title={title ?? undefined}>
      <div className="prose max-w-full text-primary">
        <CourseMarkdown>{body}</CourseMarkdown>
      </div>
    </ContentBlock>
  );
};
